import { useState } from "react";
import ComboBox from "../../components/controls/ComboBox/ComboBox";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import TextBox from "../../components/controls/TextBox/TextBox";
import FormCommand from "../../components/controls/FormCommand/FormCommand";
import { AccountDto } from "../../services/accountService";
import { MdAdd, MdInfo, MdInfoOutline } from "react-icons/md";
import Frame from "../../components/controls/Frame/Frame";
import GridView from "../../components/controls/GridView/GridView";
import tellerService, { TillRequest } from "../../services/tellerService";
import transactionService from "../../services/transactionService";

export interface CashTillFormProps {}

type tillDetails = {
  amount: number;
  denomination: number;
};

export const CashTillForm = (props: CashTillFormProps) => {
  const [tillDetails, setTillDetails] = useState<tillDetails[]>(
    Array<tillDetails>()
  );

  const [tillRequests, setTillRequests] = useState<TillRequest[]>([]);

  const [vaultAccount, setVaultAccount] = useState<AccountDto | undefined>(
    undefined
  );
  const [tillOperation, setTillOperation] = useState<string>("");
  const [amount, setAmount] = useState(0);
  const [denomination, setDenomination] = useState(0);

  return (
    <div className="row">
      <div className="col-7">
        <Frame>
          <h3>
            Till Operation{" "}
            <b>
              <small style={{ fontSize: ".5em" }}>Cash till in/out</small>
            </b>
          </h3>
          <FindAccount
            id="vaultAccount"
            text="Select Vault Account"
            onAccountSelected={(account) => {
              setVaultAccount(account);
            }}
          />

          <div className="row">
            <div className="col">
              <TextBox
                value={denomination}
                type="number"
                id="denomination"
                text="Currency Denomination"
                onLostFocus={(value) => {
                  setDenomination(value);
                }}
              />
            </div>
            <div className="col">
              <TextBox
                value={amount}
                id="amount"
                text="Enter Amount"
                type="number"
                min={1}
                step={100}
                onLostFocus={(value) => {
                  console.log("amount value " + value);
                  if (typeof value === "string") {
                    setAmount(Number(value));
                  } else {
                    setAmount(0);
                  }
                }}
              />
            </div>
            <div className="col">
              <ComboBox
                id="tillOperation"
                text="Operation"
                prompt="Select Operation"
                items={[
                  { id: "in", name: "Remit Cash" },
                  { id: "out", name: "Request Cash" },
                ]}
                onSelectionChange={(id) => {
                  setTillOperation(id);
                }}
              />
            </div>
            <div className="form-group mt-2">
              <button
                className="btn btn-outline-secondary btn-sm"
                disabled={amount === 0 || denomination === 0}
                onClick={(e) => {
                  e.preventDefault();
                  if (tillDetails === null) {
                    setTillDetails([
                      {
                        amount: amount,
                        denomination: denomination,
                      },
                    ]);
                  } else {
                    setTillDetails([
                      ...tillDetails,
                      {
                        amount: amount,
                        denomination: denomination,
                      },
                    ]);
                  }

                  // clear the fields
                  debugger;

                  setDenomination(0);
                  setVaultAccount(undefined);
                  setAmount(0);

                  console.log(tillDetails);
                }}
              >
                <MdAdd size={18} />
                <small>
                  <b>Add</b>
                </small>
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Denomination</th>
                  <th>Amount</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tillDetails?.map((d) => {
                  return (
                    <tr>
                      <td>{d.denomination}</td>
                      <td>{d.amount}</td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          id="removeTillDetail"
                          className="btn-close"
                          onClick={() => {
                            setTillDetails(
                              tillDetails.filter(
                                (c) =>
                                  c.amount !== d.amount &&
                                  c.denomination !== d.denomination
                              )
                            );
                          }}
                        ></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <FormCommand />
        </Frame>
      </div>
      <div className="col-5">
        <Frame>
          <h6>
            <b>Cash Till Requests</b>
          </h6>
          <GridView showSearchBar={false}>
            <GridView.Header>
              <tr>
                <th>Narration</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </GridView.Header>
            <GridView.Content>
              {tillRequests.length == 0 && (
                <td colSpan={3}>
                  <p className="text-center">
                    <span>
                      <MdInfo size={20} color="grey" />
                    </span>
                    No record(s) found
                  </p>
                </td>
              )}
              {tillRequests.length >= 1 &&
                tillRequests.map((d) => (
                  <tr>
                    <td>{d.narration}</td>
                    <td>{d.amount}</td>
                    <td>{d.date?.toDateString()}</td>
                    <td>
                      <span className="badge bg-secondary">
                        {d.requestStatus == 1 ? "Approved" : "Pending"}
                      </span>
                    </td>
                  </tr>
                ))}
            </GridView.Content>
          </GridView>
        </Frame>
      </div>
    </div>
  );
};
